import { KubernetesAiSavingsOpportunity } from "@/services/cloudchipr.api";
import { money } from "@/utils/numeral/money";
import { getResourceTypeName } from "@/utils/helpers/resources/getResourceTypeName";
import { ResourceDetailsTargetType } from "@/store/resource-details/utils/types/common";

export const getResourceDetailsTargetFromKubernetesAiSavingsOpportunity = (
  opportunity: KubernetesAiSavingsOpportunity,
): ResourceDetailsTargetType => {
  const k8s = {
    podsCount: 0,
    labels: opportunity.tags ?? [],
    aiKubernetesRecommendationResourceId: opportunity.resource_id ?? undefined,
    headerChips: [
      { title: "Cluster", value: opportunity.cluster?.name ?? "" },
      {
        title: "Current Monthly Price",
        value: `~${money(opportunity.current_monthly_price ?? 0)}`,
      },
      { title: "Region", value: opportunity.region },
      {
        title: "Service",
        value: getResourceTypeName(opportunity.service, {
          type: "long",
          service: true,
        }),
      },
    ],
  };

  return {
    region: opportunity.region,
    provider_unique_identifier: opportunity.resource_id ?? "",
    billing_explorer_resource_identifier: [
      opportunity.resource_name ?? opportunity.resource_id ?? "",
    ],
    name: opportunity.resource_name ?? opportunity.resource_id ?? "",
    resourceType: opportunity.service,
    provider: opportunity.cloud_provider,
    providerAccountId: opportunity.cluster?.id,
    providerAccountName: opportunity.cluster?.name ?? "",
    accountId: opportunity.cluster?.id,
    providerMetadata: {
      k8s,
    },
  };
};
